import { Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { ReportPluginModel } from '../../plugins/plugin.model';
import { Inventory } from '../../inventory/inventory.model';
import { ReportsContext } from '../reports.context';

@Component({
    selector: 'adm4-report-details',
    template: `
    <div class='full-height-flex'>
      @if (projectKey && report) {
        <adm4-column-header styleClass='nevis-green-header flex-header-stretched'>
          <div class='wrapper full-width'>
            {{report.name}}
          </div>
        </adm4-column-header>
        <div class='remaining-space-flex-content-wrapper'>
          <div class='remaining-space-flex-content report-details-container'>
            <adm4-report-generation
              [projectKey]='projectKey'
              [reportClassName]='report.className'
              [reportType]='report.reportType'
              [inventories]='inventories'
              [lastReportInfo]='reportsContext.lastReportInfo$ | async'
            ></adm4-report-generation>
          </div>
        </div>
      }
    </div>
    `,
    styleUrls: ['./report-details.component.scss'],
    standalone: false
})
export class ReportDetailsComponent implements OnChanges {
  reportsContext = inject(ReportsContext);

  @Input() projectKey: string;
  @Input() report: ReportPluginModel;
  @Input() inventories: Inventory[];

  ngOnChanges(changes: SimpleChanges) {
    if (changes.report && this.report) {
      this.reportsContext.selectReport(this.report.className);
    }
  }

}
